export default __webpack_public_path__ + "static/media/activities-icon.8fe6ae8e.svg";